// store.jsx — estado derivado del contexto padre (sin eventBus)
import { createContext } from "preact";
import { useContext, useMemo } from "preact/hooks";
import { useQuotationByIdMultiRole } from "../store"; // 👈 MISMO módulo padre

export const CardClientContext = createContext(null);

export function useCardClient() {
  const ctx = useContext(CardClientContext);
  if (!ctx) throw new Error("useCardClient must be used within CardClientProvider");
  return ctx;
}

export function CardClientProvider({ children }) {
  const { quotation, role } = useQuotationByIdMultiRole();

  const client = useMemo(
    () => (quotation?.client ? quotation.client : null),
    [quotation]
  );

  const value = useMemo(
    () => ({
      quotation,
      role,
      client,
      isReady: !!client,
    }),
    [quotation, role, client]
  );

  return (
    <CardClientContext.Provider value={value}>
      {children}
    </CardClientContext.Provider>
  );
}
